/**
 * created on: 2019.04.01
 * 广电广电文稿-广播稿-已签发路由
 */
'use strict'
angular.module('broadcastSignedRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
    	$stateProvider.state('front.editctr.broadcast.signed',{
    		url: '/signed?siteid',
            views: {
                "main@front.editctr": {
                    templateUrl: "./editingCenter/broadcast/signed/main_tpl.html",
                    controller: "broadcastSignedCtrl"
                }
            }
    	})
    }]);